import { Grid, IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import { ReactComponent as ArrowDown } from "assets/ArrowDown.svg";
import { ReactComponent as ArrowUp } from "assets/ArrowUp.svg";
import { tokens } from "styles/Tokens";
import Typography from "./Typography";

interface Props {
  label?: string;
  handleChange?: (args: any) => void;
  isOpen?: boolean;
  children: any;
  style?: any;
  sx?: any;
}

function CollapsibleContainer(props: Props) {
  const { children, style, isOpen, label, handleChange } = props;

  const handleClick = () => {
    handleChange?.((state: boolean) => !state);
  };

  return (
    <>
      <Grid>
        <Grid display="flex" flexWrap="wrap" sx={{ backgroundColor: tokens.Background.General.Primary }}>
          {label && (
            <Typography variant="body1" showBold color={tokens.Text.General.PrimaryHeadline}>
              {label}
            </Typography>
          )}
          {label && (
            <IconButton aria-label="delete" onClick={handleClick} sx={{ marginLeft: "auto" }}>
              {isOpen ? <ArrowUp /> : <ArrowDown />}
            </IconButton>
          )}
        </Grid>
        <Box sx={style}>
          <Collapse in={isOpen} sx={{ width: "100%" }}>
            {children}
          </Collapse>
        </Box>
      </Grid>
    </>
  );
}

export default CollapsibleContainer;
